// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.mobile-menu {
  position: relative;
}

.mobile-menu-icon {
  cursor: pointer;
  width: 30px;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  height: 24px;
}

.bar {
  width: 100%;
  height: 4px;
  background-color: #0B1547;
  transition: all 0.3s;
}

.bar.open:nth-child(1) {
  transform: translateY(10px) rotate(45deg);
}

.bar.open:nth-child(2) {
  opacity: 0;
}

.bar.open:nth-child(3) {
  transform: translateY(-10px) rotate(-45deg);
}

.mobile-menu-list {
  list-style: none;
  padding: 0;
  margin: 0;
  display: none;
  flex-direction: column;
  justify-content: space-between;
  background: rgba(236, 238, 238, 1);
  position: fixed;
  top: 100px;
  left: 0;
  z-index: 1000;
  height: 90vh;
  width: 100vw;
}

.mobile-menu-list.show {
  display: flex;
}

.mobile-menu-item {
  padding: 10px 20px;
  font-size: 16px;
  color: #0027f9;
  border-bottom: 1px solid #ddd;
  cursor: pointer;
}

.mobile-menu-item:last-child {
  border-bottom: none;
}

.mobile-menu-item:hover {
  background-color: #f0f0f0;
}

.menu-title:hover {
  color: #0027f9 !important;
}

.mobile-menu-content {
  padding-left: 30px;
  padding-right: 30px;
}

.mobile-submenu {
  list-style: none;
  padding: 5px 0 0 20px;
  margin: 0;
}

.mobile-submenu-item {
  padding: 5px 0;
  font-size: 14px;
  color: #616161 !important;
}

.mobile-menu-link {
  color: #616161 !important;
}

.mobile-submenu-item:hover {
  color: #0027f9;
}

.mobile-menu-header {
  margin-top: 64px;
  padding-left: 16px;
  padding-right: 16px;
  margin-bottom: 24px;
}

.mobile-menu-header-content {
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  border: 0.5px solid #FFF;
  border-radius: 100px;
  padding: 21px 33px;
  align-items: center;
}

.ant-layout-header .mobile-menu-header-content {
  line-height: 0px !important
}

.menu-item .ant-collapse-content {
  border-top: 1px solid #D3D3D3 !important;
}

.mobile-menu-actions {
  display: flex;
  flex-direction: column;
  margin: 0 16px;
  padding-bottom: 50px;
  text-align: center;
}

/* Scroll para Markets */
.mobile-markets-scroll {
  max-height: 200px;
  overflow-y: auto;
  padding-right: 8px;
}

/* Bloque de cada región */
.mobile-region-block {
  margin-bottom: 24px;
}

/* Título de la región */
.mobile-region-title {
  font-size: 15px;
  font-weight: bold;
  color: #0027F9;
  margin-bottom: 12px;
}

/* Lista de países */
.mobile-markets-list {
  list-style: none;
  margin: 0;
  padding-left: 12px;
}

/* Estilo de país */
.mobile-market-item {
  padding: 4px 0;
}

.mobile-market-link {
  color: #616161 !important;
  font-size: 14px;
  text-decoration: none;
}

.mobile-market-link:hover {
  color: #0027F9 !important;
}
`, "",{"version":3,"sources":["webpack://./src/css/MobileMenu.css"],"names":[],"mappings":"AAAA;EACE,kBAAkB;AACpB;;AAEA;EACE,eAAe;EACf,WAAW;EACX,aAAa;EACb,sBAAsB;EACtB,8BAA8B;EAC9B,YAAY;AACd;;AAEA;EACE,WAAW;EACX,WAAW;EACX,yBAAyB;EACzB,oBAAoB;AACtB;;AAEA;EACE,yCAAyC;AAC3C;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,2CAA2C;AAC7C;;AAEA;EACE,gBAAgB;EAChB,UAAU;EACV,SAAS;EACT,aAAa;EACb,sBAAsB;EACtB,8BAA8B;EAC9B,kCAAkC;EAClC,eAAe;EACf,UAAU;EACV,OAAO;EACP,aAAa;EACb,YAAY;EACZ,YAAY;AACd;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,kBAAkB;EAClB,eAAe;EACf,cAAc;EACd,6BAA6B;EAC7B,eAAe;AACjB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,kBAAkB;EAClB,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;EAChB,qBAAqB;EACrB,SAAS;AACX;;AAEA;EACE,cAAc;EACd,eAAe;EACf,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,gBAAgB;EAChB,kBAAkB;EAClB,mBAAmB;EACnB,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,wBAAwB;EACxB,oBAAoB;EACpB,kBAAkB;EAClB,mBAAmB;AACrB;;AAEA;EACE;AACF;;AAEA;EACE,wCAAwC;AAC1C;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,cAAc;EACd,oBAAoB;EACpB,kBAAkB;AACpB;;AAEA,wBAAwB;AACxB;EACE,iBAAiB;EACjB,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA,0BAA0B;AAC1B;EACE,mBAAmB;AACrB;;AAEA,wBAAwB;AACxB;EACE,eAAe;EACf,iBAAiB;EACjB,cAAc;EACd,mBAAmB;AACrB;;AAEA,oBAAoB;AACpB;EACE,gBAAgB;EAChB,SAAS;EACT,kBAAkB;AACpB;;AAEA,mBAAmB;AACnB;EACE,cAAc;AAChB;;AAEA;EACE,yBAAyB;EACzB,eAAe;EACf,qBAAqB;AACvB;;AAEA;EACE,yBAAyB;AAC3B","sourcesContent":[".mobile-menu {\n  position: relative;\n}\n\n.mobile-menu-icon {\n  cursor: pointer;\n  width: 30px;\n  display: flex;\n  flex-direction: column;\n  justify-content: space-between;\n  height: 24px;\n}\n\n.bar {\n  width: 100%;\n  height: 4px;\n  background-color: #0B1547;\n  transition: all 0.3s;\n}\n\n.bar.open:nth-child(1) {\n  transform: translateY(10px) rotate(45deg);\n}\n\n.bar.open:nth-child(2) {\n  opacity: 0;\n}\n\n.bar.open:nth-child(3) {\n  transform: translateY(-10px) rotate(-45deg);\n}\n\n.mobile-menu-list {\n  list-style: none;\n  padding: 0;\n  margin: 0;\n  display: none;\n  flex-direction: column;\n  justify-content: space-between;\n  background: rgba(236, 238, 238, 1);\n  position: fixed;\n  top: 100px;\n  left: 0;\n  z-index: 1000;\n  height: 90vh;\n  width: 100vw;\n}\n\n.mobile-menu-list.show {\n  display: flex;\n}\n\n.mobile-menu-item {\n  padding: 10px 20px;\n  font-size: 16px;\n  color: #0027f9;\n  border-bottom: 1px solid #ddd;\n  cursor: pointer;\n}\n\n.mobile-menu-item:last-child {\n  border-bottom: none;\n}\n\n.mobile-menu-item:hover {\n  background-color: #f0f0f0;\n}\n\n.menu-title:hover {\n  color: #0027f9 !important;\n}\n\n.mobile-menu-content {\n  padding-left: 30px;\n  padding-right: 30px;\n}\n\n.mobile-submenu {\n  list-style: none;\n  padding: 5px 0 0 20px;\n  margin: 0;\n}\n\n.mobile-submenu-item {\n  padding: 5px 0;\n  font-size: 14px;\n  color: #616161 !important;\n}\n\n.mobile-menu-link {\n  color: #616161 !important;\n}\n\n.mobile-submenu-item:hover {\n  color: #0027f9;\n}\n\n.mobile-menu-header {\n  margin-top: 64px;\n  padding-left: 16px;\n  padding-right: 16px;\n  margin-bottom: 24px;\n}\n\n.mobile-menu-header-content {\n  display: flex;\n  flex-direction: row;\n  justify-content: space-between;\n  border: 0.5px solid #FFF;\n  border-radius: 100px;\n  padding: 21px 33px;\n  align-items: center;\n}\n\n.ant-layout-header .mobile-menu-header-content {\n  line-height: 0px !important\n}\n\n.menu-item .ant-collapse-content {\n  border-top: 1px solid #D3D3D3 !important;\n}\n\n.mobile-menu-actions {\n  display: flex;\n  flex-direction: column;\n  margin: 0 16px;\n  padding-bottom: 50px;\n  text-align: center;\n}\n\n/* Scroll para Markets */\n.mobile-markets-scroll {\n  max-height: 200px;\n  overflow-y: auto;\n  padding-right: 8px;\n}\n\n/* Bloque de cada región */\n.mobile-region-block {\n  margin-bottom: 24px;\n}\n\n/* Título de la región */\n.mobile-region-title {\n  font-size: 15px;\n  font-weight: bold;\n  color: #0027F9;\n  margin-bottom: 12px;\n}\n\n/* Lista de países */\n.mobile-markets-list {\n  list-style: none;\n  margin: 0;\n  padding-left: 12px;\n}\n\n/* Estilo de país */\n.mobile-market-item {\n  padding: 4px 0;\n}\n\n.mobile-market-link {\n  color: #616161 !important;\n  font-size: 14px;\n  text-decoration: none;\n}\n\n.mobile-market-link:hover {\n  color: #0027F9 !important;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
